import Dialog from '@mui/material/Dialog';
import { useTranslate } from 'react-admin';
import MultiSelectionProvider from 'utils/providers/MultiSelectionProvider';
import { FileManagerModalInputDialogContent } from './FileManagerModalInputDialogContent';

interface FileManagerModalProps {
  showDialog: boolean,
  handleSelectClick: (selection: Array<any>) => void,
  handleCloseClick: () => void,
  label?: string,
  source?: string,
}
const FileManagerModal = ({ source, showDialog, handleSelectClick, handleCloseClick, label }: FileManagerModalProps) => {
  const translate = useTranslate();
  
  return (
    <Dialog
      maxWidth={"xl"}
      fullWidth
      open={showDialog}
      onClose={handleCloseClick}
      aria-label={translate("ra.action.file_manager")}
    >
      <MultiSelectionProvider>
        <FileManagerModalInputDialogContent source={source} handleCloseClick={handleCloseClick} handleSelectClick={handleSelectClick} />
      </MultiSelectionProvider>
    </Dialog>
  )
}
FileManagerModal.defaultProps = {
  label: 'ra.action.file_manager',
}

export default FileManagerModal